<template>
    <div class="time-counter">
        <div class="text">剩餘時間</div>
        <div class="bar">
            <div class="rest-bar" :style="{ width: `${percentage}%` }" />
        </div>
        <div class="rest-time">{{ restTime }} s</div>
    </div>
</template>

<script>
let INTERVAL;
export default {
    props: { time: Number },
    data() {
        return {
            restTime: 0,
        };
    },
    created() {
        this.restTime = this.time;
    },
    computed: {
        percentage() {
            return (this.restTime / this.time) * 100;
        },
    },
    destroyed() {
        clearInterval(INTERVAL);
    },
    methods: {
        onStart() {
            INTERVAL = setInterval(() => {
                if (this.restTime === 0) {
                    this.$emit('due');
                    clearInterval(INTERVAL);
                } else {
                    this.restTime -= 1;
                    this.$emit('tick', this.restTime);
                }
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
.time-counter {
    margin-top: 20px;
    width: 100%;
    font-size: 1.2em;
    display: flex;
    justify-content: center;
    align-items: center;
    .bar {
        margin: 0 10px;
        width: 190px;
        height: 20px;
        border-radius: 10.9px;
        background-color: #dbe6ea;
        overflow: hidden;
    }
    .rest-bar {
        transition: 1s linear;
        width: 50%;
        height: 100%;
        border-radius: 10.9px;
        background-color: #56a1e6;
    }
    .rest-time {
        width: 45px;
        white-space: nowrap;
        text-align: right;
    }
    @media screen and (max-width: 320px) {
        margin-top: 30px;
        font-size: 1em;
    }
}
</style>
